import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DropdownOptions, EnglishArabicDTO, FilterItem, FilterType, InputType, MultiLingualTextBoxOptions, PagingOptions, TextBoxOptions } from 'bnsights-control-library';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { PageInfoService } from '../../../_metronic/core/services/page-info.service';
import { PermissionModel } from '../../shared/models/PermissionsModels/PermissionModel';
import { UsersIDRequestModel } from '../../shared/models/UserModels/UsersIDRequestModel';
import { DataSecretService } from '../../shared/Services/data.service';
import { PermissionsService } from './../../shared/Services/PermissionsService.service';
import { AuthService, UtilityService, BBSFTranslateService, EnvironmentService } from 'bnsights-utilities-library';

@Component({
  selector: 'lib-permissions',
  templateUrl: './permissions.component.html'
})
export class PermissionsComponent implements OnInit {
  ApiUrl = "/api/admin/Permissions/"
  SubheaderTitle = this.utilityService.getResourceValue('Permissions');
  

  ShowToolbar = true; ShowbreadCrumb = false;
  searchTextBox: TextBoxOptions;
  OrganizationList = [];
  filterForm = new FormGroup({});
  PermissionsForm = new FormGroup({});
  showFilter: boolean = false;
  PermissionsPagingResult: any[] = [];
  PermissionsPaging: PagingOptions;
  TextInputFilter: FilterItem;
  IsFilterLoaded: boolean = false;
  ProductionMode: boolean;
  @ViewChild('PermissionPagingViewElement', { static: false }) input: ElementRef;


   //Add Model Controls
   AddPermissionForm = new FormGroup({});
   MultiLingualName:MultiLingualTextBoxOptions
   SysName: TextBoxOptions;
   Organization: DropdownOptions;
   IsAddPermissionFormLoaded: boolean = false;
   @ViewChild('ClosePermissionModal', { static: false }) ClosePermissionModal: ElementRef;


   //Edit Model Controls
  EditPermissionForm = new FormGroup({});
  EditMultiLingualName:MultiLingualTextBoxOptions
  EditSysName: TextBoxOptions;
  EditOrganization: DropdownOptions;
  IsEditPermissionModelLoaded: boolean;
  PermissionId: number;
  @ViewChild('CloseEditPermissionsModal', { static: false }) CloseEditPermissionsModal: ElementRef;

  //delete  Model Controls
  deletePermissionsList: any[] = []
  IsOpenDeletePermissionsModal: boolean = false
  @ViewChild('CloseDeletePermissionsModal', { static: false }) CloseDeletePermissionsModal: ElementRef;



  //Confirmation  Model Controls
  IsOpenConfirmationModal: boolean;
  ConfirmationModalType: number = 0;
  ConfirmationMessage: string = "";
  @ViewChild('CloseConfirmationModal', { static: false }) CloseConfirmationModal: ElementRef;

  // Decorator wires up blockUI instance
  @BlockUI() blockUI: NgBlockUI;
  ShowPageContent:boolean=false;
  language:string=""
  constructor(private pageInfoService:PageInfoService, public utilityService:UtilityService,private bbsfTranslateService:BBSFTranslateService,private environmentService:EnvironmentService, private dataServices: DataSecretService, private authService: AuthService, private PermissionsService: PermissionsService) 
  { 
  }

  async ngOnInit(): Promise<void> {
    this.ShowPageContent=true;
    PageInfoService.PageTitle=this.utilityService.getResourceValue("Permission")
    PageInfoService.PageBreadcrumbs=[
       {title: this.utilityService.getResourceValue("Home") , path: '/Admin/Home', isSeparator: false, isActive: false},
       {title: '', path: '', isSeparator: true, isActive: false}

    ];
    this.pageInfoService.calculateTitle();
    this.pageInfoService.calculateBreadcrumbs();
    this.bbsfTranslateService.onLangChange.subscribe((event)=>{
      this.ShowPageContent=false;
      this.language = event.lang;
      this.ngOnInit();
    })
    this.language =  await this.utilityService.getCurrentLanguage();
    this.ProductionMode = this.environmentService.getProductionMode()
    this.LoadDropdownLists();
  }

  
  ReinitializePermissionsPaging() {
    let element = this.input as any;
    element.ReinitializePaging();
  }

  UpdatePermissionsPaging() {
    let element = this.input as any;
    element.UpdatePaging();
  }

  setPermissionsListResult(result) {
    this.PermissionsPagingResult = result
    this.ShowPageContent=true;
    this.utilityService.stopBlockUI()
  }

  resetFilters() {
   this.PermissionsForm.controls["searchTextBox"].setValue(null);
    let element = this.input as any;
    element.ReinitializePaging();
  }

  LoadDropdownLists() {

    this.PermissionsService.Loaddropdowns().subscribe((result) => {
      let DropdownsResponseModel = result as any;
      this.OrganizationList = DropdownsResponseModel;
       // TextBox inti
      this.searchTextBox = new TextBoxOptions();
      this.searchTextBox.Name = "searchTextBox"
      this.searchTextBox.HideLabel = true
      this.searchTextBox.Type = InputType.Text
      this.searchTextBox.Placeholder = this.utilityService.getResourceValue("SearchByName")
    
      this.TextInputFilter = new FilterItem();
      this.TextInputFilter.FormControlName = "searchTextBox"
      this.TextInputFilter.ActionParameterName = "searchText"
      this.TextInputFilter.IsFormControl = true
      this.TextInputFilter.FilterType = FilterType.TextBox


      this.PermissionsPaging = new PagingOptions();
      this.PermissionsPaging.ActionPostURL = this.environmentService.getApiUrl() + this.ApiUrl + 'GetPermissionsByFilter';
      this.PermissionsPaging.OnKeyPressFiltersControlNames = ["searchTextBox"]
      this.PermissionsPaging.Filters = [this.TextInputFilter]
      this.PermissionsPaging.ValidationToken = this.authService.authorizationHeaderValue();
        this.IsFilterLoaded = true;
    
    })
  }

  showAddPermissionModal() {
    this.AddPermissionForm.reset();
    this.IsAddPermissionFormLoaded = false
    this.utilityService.startBlockUI();

    this.MultiLingualName = new MultiLingualTextBoxOptions();
    this.MultiLingualName.Name = "Name";
    this.MultiLingualName.ArabicLabelKey = "NameInArabic";
    this.MultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.MultiLingualName.IsRequired = true;
    this.MultiLingualName.Value = null;

    
    this.SysName = new TextBoxOptions();
    this.SysName.Name = "SysName";
    this.SysName.LabelKey = "SysName";
    this.SysName.Type = InputType.Text;
    this.SysName.Value = null;

    this.Organization = new DropdownOptions();
    this.Organization.Name = "Organization"
    this.Organization.LabelKey = "Organization"
    this.Organization.SelectedItems = null;
    this.Organization.DataSource = this.OrganizationList
    this.Organization.SingleSelection = true;
    this.Organization.AllowSearchFilter = true;
    this.Organization.IsRequired = true;

    setTimeout(() => {
      this.IsAddPermissionFormLoaded = true;
      this.utilityService.stopBlockUI();
    }, 100);
  }

  addPermission() {
    if (this.AddPermissionForm.invalid) {
      return;
    }
    else {
      let ResultModel = this.AddPermissionForm.value;
      let AddPermissionModel:PermissionModel= new PermissionModel() ;
      if(this.ProductionMode==false)
      AddPermissionModel.SysName = ResultModel.SysName;
      AddPermissionModel.Name.Arabic = ResultModel.Name.Arabic;
      AddPermissionModel.Name.English = ResultModel.Name.English;
      AddPermissionModel.OrganizationID = Number(ResultModel.Organization);
     this.PermissionsService.AddPermission(AddPermissionModel).subscribe((result) => {
        document.getElementById('ClosePermissionModal').click()
        this.AddPermissionForm.reset()
        let element = this.input as any;
        element.ReinitializePaging();
      }, (error) => {
      })
    }
  }


  showEditPermissionModal(Permission: any) {

    this.IsEditPermissionModelLoaded = false;
    this.utilityService.startBlockUI();
    this.EditPermissionForm.reset();

    let Name=new EnglishArabicDTO();
    Name.Arabic=Permission.name.arabic;
    Name.English=Permission.name.english;

    this.EditMultiLingualName = new MultiLingualTextBoxOptions();
    this.EditMultiLingualName.Name = "Name";
    this.EditMultiLingualName.ArabicLabelKey = "NameInArabic";
    this.EditMultiLingualName.EnglishLabelKey = "NameInEnglish";
    this.EditMultiLingualName.IsRequired = true;
    this.EditMultiLingualName.Value = Name;
    

    this.PermissionId = Permission.id

    this.EditSysName = new TextBoxOptions();
    this.EditSysName.Name = "SysName";
    this.EditSysName.LabelKey = "SysName";
    this.EditSysName.Type = InputType.Text;
    this.EditSysName.Value = Permission.sysName;
   
    this.EditOrganization = new DropdownOptions();
    this.EditOrganization.Name = "Organization"
    this.EditOrganization.LabelKey = "Organization"
    this.EditOrganization.SelectedItems = this.OrganizationList.filter((item) => { return parseInt(item.key) == Permission.organizationID; }).map((item) => item.key)[0];
    this.EditOrganization.DataSource = this.OrganizationList
    this.EditOrganization.SingleSelection = true;
    this.EditOrganization.AllowSearchFilter = true;
    this.EditOrganization.IsRequired = true;


   

    setTimeout(() => {
      this.IsEditPermissionModelLoaded = true;
      this.utilityService.stopBlockUI();
    }, 100);

  }

  editPermission() {
    if (this.EditPermissionForm.invalid) {
      return;
    }
    else {
      this.utilityService.startBlockUI();
      let ResultModel = this.EditPermissionForm.value;
      let EditPermissionModel = new PermissionModel();
      EditPermissionModel.Id = this.PermissionId;
    
      EditPermissionModel.Name.Arabic = ResultModel.Name.Arabic;
      EditPermissionModel.Name.English = ResultModel.Name.English;

      if(this.ProductionMode==false)
      EditPermissionModel.SysName = ResultModel.SydName;
      EditPermissionModel.OrganizationID = Number(ResultModel.Organization);
      this.PermissionsService.EditPermission(EditPermissionModel).subscribe((result) => {
         ;
        document.getElementById('CloseEditPermissionsModal').click()
        this.EditPermissionForm.reset()
        let element = this.input as any;
        element.UpdatePaging();
      }, (error) => {
      
      })
    }
  }


  showDeletePermissionModal(Resource: any) {
    this.deletePermissionsList = []
    this.deletePermissionsList.push(Resource);
    this.IsOpenDeletePermissionsModal = false;
    this.utilityService.startBlockUI();
    setTimeout(() => {
      this.IsOpenDeletePermissionsModal = true;
      this.utilityService.stopBlockUI();
    }, 100);

  }

  deletePermission() {
    let  UsersIDModel:UsersIDRequestModel= new UsersIDRequestModel() ;
     for (let index = 0; index < this.deletePermissionsList.length; index++) {
       const element = this.deletePermissionsList[index];
       UsersIDModel.UsersIDs.push(element.id)
       
     }
    this.PermissionsService.DeletePermission(UsersIDModel).subscribe((result) => {
      this.deletePermissionsList = [];
      document.getElementById('CloseDeletePermissionsModal').click()
      let element = this.input as any;
      element.ReinitializePaging();
    }, (error) => {

    })

  }






}
